<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "TAXS.TAX" | translate | uppercase }}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="center p-24 pb-56">
        <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
            <app-search-regiones
                class="mb-16"
                *ngIf="regiones"
                [regiones]="regiones"
                (regionEvent)="buscaComunas($event)"
            >
            </app-search-regiones>

            <div class="content p-24" fusePerfectScrollbar>
                <app-tabla-comunas
                    *ngIf="comunas"
                    [comunas]="comunas"
                    [procesando]="procesando"
                    (guardarRecargoEvent)="guardarRecargo($event)"
                ></app-tabla-comunas>
            </div>
        </div>
    </div>
    <!-- / CONTENT -->
</div>
